import React from 'react';
import PropTypes from 'prop-types';
// 1. Swap the Field import
import { Field } from 'react-final-form';
import WrappedFormIncrementalStepper from './WrappedFormIncrementalStepper';

function FormIncrementalStepper(props) {
  // 2. The syntax remains very similar, but react-final-form 
  // will pass { input, meta } to WrappedFormIncrementalStepper.
  return <Field component={WrappedFormIncrementalStepper} {...props} />;
}

FormIncrementalStepper.propTypes = {
  name: PropTypes.string.isRequired
};

export default FormIncrementalStepper;
